import * as React from 'react';
import themePrimary from '../../styles/themePrimary';
import { Typography, makeStyles, useMediaQuery, Dialog, AppBar, IconButton, Toolbar, Slide } from '@material-ui/core';
import { UserStateContext } from '../../providers/UserStateContextProvider';
import { CheckOutStateContext } from '../../providers/CheckOutStateContextProvider';
import CloseIcon from '@material-ui/icons/Close';
import { TransitionProps } from '@material-ui/core/transitions';
import { String_ViewReceiptDialog_ViewReceiptLabel } from '../../utilities/StringHelper';
import { ElementDimensions } from '../../styles/ElementDimensions';
import { Skin } from '../../models/common/Skin';
import ViewReceipt from './ViewReceipt';

const useStyles = makeStyles({
    appBar: {
        height: ElementDimensions.dialogBarHeight + 'px',
        position: 'relative',
        backgroundColor: props => (props as Skin).primary_main_color + ' !important',
    },
    checkDetailsContainer: {
        backgroundColor: themePrimary.palette.grey[100],
        borderRadius: '6px',
        marginLeft:  ElementDimensions.margin10 + 'px',
        marginRight:  ElementDimensions.margin10 + 'px',
    },
    closeButton: {
        height: '30px',
        width: '30px',
        color: themePrimary.palette.primary.contrastText,
    },
    details: {
        position: 'absolute',
        top: ElementDimensions.dialogBarHeight + 'px',
        bottom: 0,
        left: 0,
        right: 0,
        width: '100%',
        overflowY: 'scroll',
        overflowX: 'hidden',
    },
    dialog: {
        backgroundColor: themePrimary.palette.secondary.light,
    },
    dialogLandscape: {
        backgroundColor: themePrimary.palette.secondary.light,
        left: 'calc(100vw *.3) !important',
        width: 'calc(100vw *.7)',
    },
    headerContainer: {
        paddingLeft: ElementDimensions.padding10 + 'px',
        paddingRight: ElementDimensions.padding10 + 'px',
        paddingTop: ElementDimensions.padding5 + 'px',
        paddingBottom: ElementDimensions.padding5 + 'px',
        width: '100%',
        fontFamily: 'LeagueSpartan-Bold !important',
    },
    headerGrid: {
        display: 'grid',
        gridTemplateColumns: 'auto auto',
        width: '100%',
    },
    headerGridContainer: {
        display: 'flex',
    },
    headerTextLeft: {
        fontSize: '1rem',
        lineHeight: '1.6rem',  
        color: themePrimary.palette.secondary.contrastText,
    },
    headerTextRight: {
        fontSize: '1rem',
        lineHeight: '1.6rem',  
        textAlign: 'right',
        color: themePrimary.palette.secondary.contrastText,
    },
    sigContainer: {
        textAlign: 'center',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginBottom: ElementDimensions.margin20 + 'px',
        width: '90%',
        height: '100px',
    },
    sigImage: {
        width: '95%',
        height: '95%',
    },
    titleContainer: {
        display: 'flex',
        textAlign: 'center',
        padding: ElementDimensions.padding5 + 'px',
    },
    titleInnerContainer: {
        marginTop: 'auto',
        marginBottom: 'auto',
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    title: {
        marginLeft: ElementDimensions.margin10 + 'px',
        flex: 1,
        color: themePrimary.palette.primary.contrastText,
    },
});

export type ViewReceiptDialogCloseClickHandler = (event: React.MouseEvent<HTMLElement>) => any;

export interface ViewReceiptDialogProps {
    paymentId: string;
    open: boolean;
    onCloseHandler: ViewReceiptDialogCloseClickHandler;
}

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & { children?: React.ReactElement },
    ref: React.Ref<unknown>,
  ) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const ViewReceiptDialog = (props: ViewReceiptDialogProps) => {
    const isPortrait = true;
    const { paymentId, open, onCloseHandler } = props;
    const userState = React.useContext(UserStateContext);
    const checkOutState = React.useContext(CheckOutStateContext);
    const classes = useStyles({ primary_main_color: checkOutState.state.skin.primary_main_color, 
        primary_light_color: checkOutState.state.skin.primary_light_color, primary_dark_color: checkOutState.state.skin.primary_dark_color });

    const handleClose = (event: React.MouseEvent<HTMLElement>) => {
        onCloseHandler(event);
    };

    return (
        <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition} className={isPortrait === true ? classes.dialog : classes.dialogLandscape}>
            <AppBar className={classes.appBar}>
                <Toolbar>
                    <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                        <CloseIcon className={classes.closeButton} />
                    </IconButton>
                    <Typography variant="h6" className={classes.title}>
                        {String_ViewReceiptDialog_ViewReceiptLabel.find(s => s.key === userState.state.locale)!!.value}
                    </Typography>
                </Toolbar>
            </AppBar>
            <ViewReceipt
                paymentId={paymentId}/>
        </Dialog>
    );
};

export default ViewReceiptDialog;